import { render, staticRenderFns } from "./TheadConsolidated.vue?vue&type=template&id=3ff06349"
import script from "./TheadConsolidated.vue?vue&type=script&lang=js"
export * from "./TheadConsolidated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports